// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
// Application configuration — replaces AppModule providers and NgModule bootstrapping
import { ApplicationConfig, provideAppInitializer, inject, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideStore, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IxModule } from '@siemens/ix-angular';

import { routes } from './app.routes';
import { reducersApplicationState } from './app-states/app.state';
import { AppEffects } from './app-states/app.effect';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';
import { appInitializer } from './appInitializer';
import { AppEnvironmentService } from './services/app-environment.service';
import { AuthService } from './services/auth/auth.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', `.json?cb=${Date.now()}`);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideStore({}),
    provideState('ApplicationState', reducersApplicationState),
    provideEffects([AppEffects]),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true
    },
    provideAppInitializer(() => {
      const initFn = appInitializer(inject(AppEnvironmentService), inject(AuthService));
      return initFn();
    }),
    importProvidersFrom(
      IxModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
};
